import http from 'hub-http/clients/apiClient';
const CRM_SEARCH_URI = 'crm-search/search';
export const getCampaign = (guid, properties = ['hs_name', 'hs_utm']) => {
  return http.post(CRM_SEARCH_URI, {
    data: {
      count: 1,
      offset: 0,
      objectTypeId: '0-35',
      requestOptions: {
        properties
      },
      filterGroups: [{
        filters: [{
          property: 'hs_origin_asset_id',
          value: guid,
          operator: 'EQ'
        }]
      }],
      sorts: [{
        property: 'hs_name',
        order: 'ASC'
      }],
      query: null
    }
  }).then(res => {
    const crmData = res.results[0];
    return properties.reduce((acc, currProperty) => Object.assign({}, acc, {
      [currProperty]: crmData.properties[currProperty].value
    }), {});
  });
};
export const getCampaignName = guid => getCampaign(guid).then(res => res.hs_name);